module.exports = angular.module('cartographer.app.form', [])

$ = require 'jquery'
_ = require 'underscore'

module.exports.directive 'crtForm', $DI (crtLog, $interpolate, $parse, $timeout, crtPromise, crtAuth, crtString, crtConfig, crtPage, crtModal, crtFormUtil) ->
  return {
    restrict: 'A'
    transclude: true
    template: '<div ng-transclude></div>'
    require: [ 'crtForm', 'form' ]
    scope: false
    controller: $DI ($scope) ->
      return this
    compile: (element, attrs, controllers) ->
      return {
        pre: ($scope, element, attrs, controllers) ->
          [ crtForm, form ] = controllers

          crtForm.model       = $parse(attrs.model)($scope)
          crtForm.save        = $parse(attrs.save)($scope)
          crtForm._validate   = $parse(attrs.validate)($scope)
          crtForm.validate    = -> crtForm._validate(crtForm.model)
          crtForm.enabled     = if attrs.enabled then !!$parse(attrs.enabled)($scope) else true
          crtForm.modelPrefix = attrs.modelPrefix ? $interpolate(attrs.model)($scope)

          crtLog.debug('crtForm.link.pre', crtForm, $scope)

          # State accessed by child directives:
          crtForm.errors          = []
          crtForm.errorsByPrefix  = {}
          crtForm.numWarnings     = 0
          crtForm.numErrors       = 0
          crtForm.validationCount = 0 # incremented each time crtForm.errors changes

          queuedChangesToErrors = []
          queueChangesToErrors = (source, calculateErrors) ->
            calculateNormalizedErrors = ->
              _.map calculateErrors(), (error) ->
                crtFormUtil.normalizeError(error, source)

            queuedChangesToErrors = _.reject(
              queuedChangesToErrors
              (change) -> change.source == source
            ).concat([{ source: source, calculateErrors: calculateNormalizedErrors }])

            return

          setInputErrors = (inputName, calculateErrors) ->
            queueChangesToErrors(inputName, calculateErrors)
            return

          setClientErrors = (calculateErrors) ->
            queueChangesToErrors("client", calculateErrors)
            return

          setServerErrors = (calculateErrors) ->
            queueChangesToErrors("server", calculateErrors)
            return

          queuedChangesTimer = null
          resetQueuedChangesTimer = (delay) ->
            # crtLog.debug('resetQueuedChangesTimer', delay, new Date().getTime())

            $timeout.cancel(queuedChangesTimer)

            if delay < 0
              queuedChangesTimer = null
              applyQueuedChangesToErrors()
            else
              queuedChangesTimer = $timeout(applyQueuedChangesToErrors, delay)

            return

          applyQueuedChangesToErrors = ->
            # crtLog.debug('applyQueuedChangesToErrors', new Date().getTime())
            queue = queuedChangesToErrors
            queuedChangesToErrors = []

            # Cache for logging purposes:
            oldErrors = [].concat(crtForm.errors)

            # Arguments to pass to $broadcast later on:
            added   = []
            removed = []

            # Update errors list:
            for { source, calculateErrors } in queue
              errors = calculateErrors()
              crtForm.errors = _.reject(crtForm.errors, (error) -> error.source == source).concat(errors)

            # Hash by prefix:
            crtForm.errorsByPrefix = {}
            for error in crtForm.errors
              for prefix in error.prefixes
                crtForm.errorsByPrefix[prefix] ?= []
                crtForm.errorsByPrefix[prefix].push(error)

            # Update overall error counts:
            crtForm.numWarnings = 0
            crtForm.numErrors   = 0
            for error in crtForm.errors
              switch error.level
                when 'warning' then crtForm.numWarnings = crtForm.numWarnings + 1
                when 'error'   then crtForm.numErrors   = crtForm.numErrors   + 1

            crtForm.validationCount = crtForm.validationCount + 1

            return

          crtForm.reportingAllErrors = false

          crtForm.setReportingAllErrors = (value) ->
            # crtLog.debug('crtForm.setReportingAllErrors', value)
            crtForm.reportingAllErrors = value
            $scope.$broadcast('form:setReportingErrors', crtForm.reportingAllErrors)
            return

          crtForm.unreportedErrors = ->
            _.reject crtForm.errors, (error) ->
              error.reported

          crtForm.revalidate = ->
            # crtLog.debug('crtForm.revalidate')
            setClientErrors(crtForm.validate)
            resetQueuedChangesTimer(crtConfig.form.slowValidationDelay)
            return

          unbindInputUpdated = $scope.$on 'form:inputUpdated', (evt, inputName, errors = []) ->
            # crtLog.debug('form:inputUpdated', inputName, errors)
            evt.stopPropagation()
            setInputErrors(inputName, -> errors)
            setClientErrors(crtForm.validate)
            resetQueuedChangesTimer(crtConfig.form.slowValidationDelay)
            return

          unbindInputRemoved = $scope.$on 'form:inputRemoved', (evt, inputName) ->
            # crtLog.debug('form:inputRemoved', inputName)
            evt.stopPropagation()
            setInputErrors(inputName, -> [])
            setClientErrors(crtForm.validate)
            resetQueuedChangesTimer(crtConfig.form.slowValidationDelay)
            return

          unbindSubmit = $scope.$on 'form:submit', (evt, complete = (->)) ->
            evt.stopPropagation()
            crtForm.submit(complete)
            return

          $scope.$on '$destroy', ->
            unbindInputUpdated()
            unbindInputRemoved()
            unbindSubmit()
            return

          # (result -> any) -> promiseOf(result)
          # where result: { value: model, errors: arrayOf(error), original: model, saved: boolean }
          crtForm.submit = (complete = (->)) ->
            crtLog.debug('crtForm.submit', $scope)

            # If we're not already showing errors, start doing so:
            wasReportingErrors = crtForm.reportingAllErrors
            crtForm.setReportingAllErrors(true)

            # Synchronously calculate client-side errors:
            setServerErrors(-> [])
            setClientErrors(crtForm.validate)
            resetQueuedChangesTimer(-1)

            # First pass at validation (client-side):
            #  - if there are any actual errors, we have to abort;
            #  - if there are any warnings that the user hasn't seen, we also abort
            #    (the form will start showing warnings and the user can submit again if they like).
            if crtForm.numErrors > 0 || (!wasReportingErrors && crtForm.numWarnings > 0)
              crtPromise.create({ value: crtForm.model, errors: crtForm.errors, saved: false })
            else
              # At this point, we know that there are no client-side validation errors that we have to worry about.
              # We can submit the form to the server:
              crtForm.save(crtForm.model).then (checked) ->
                # The server returns a value OR errors. We fill them both back in here:
                checked.value  ?= crtForm.model
                checked.errors ?= []
                # Synchronously calculate server-side errors:
                setServerErrors(-> checked.errors)
                resetQueuedChangesTimer(-1)

                # If the server returned no errors, we know the data has been saved.
                # We update the values of `original` and `model` to reflect the canonical state
                # of the saved data:
                if crtForm.numErrors > 0
                  # The server returned errors, so we do nothing.
                  # The method falls through and we end up displaying the errors to the user.
                  crtPromise.create({ value: crtForm.model, errors: crtForm.errors, saved: false })
                else
                  $.extend(true, crtForm.model, checked.value)

                  # The server returned no errors, so we look for warnings:
                  if _.filter(checked.errors, (error) -> error.level == 'warning').length > 0
                    form.$setPristine()
                    crtPromise
                      .create({ value: checked.value, errors: crtForm.errors, saved: true })
                      .then(complete)

                    # # If there were warnings, we ask the user if they want to review them before leaving:
                    # crtModal.ask
                    #   title    : "Alert"
                    #   content  : """
                    #              Your changes were saved but the server returned extra warnings.
                    #              Would you like to review the form again before continuing?
                    #              """
                    #   noLabel  : "Review the warnings"
                    #   yesLabel : "Ignore and continue"
                    # .then (confirmContinue) ->
                    #   if confirmContinue
                    #     # The user wants to ignore the errors.
                    #     # We call `complete()` as we would have done if there were no warnings:
                    #     form.$setPristine()
                    #     crtPromise
                    #       .create({ value: checked.value, errors: crtForm.errors, saved: true })
                    #       .then(complete)
                    #   else
                    #     # The user wants to look at the warnings on the form.
                    #     # We do nothing, the method falls through, and they end up looking at the warnings.
                    #     crtPromise.create({ value: crtForm.model, errors: crtForm.errors, saved: false })
                  else
                    form.$setPristine()
                    # If there are no warnings, we call `complete()`, which typically navigates to a different page.
                    # This method falls through to the end and we end up on the new page:
                    crtPromise
                      .create({ value: checked.value, errors: crtForm.errors, saved: true })
                      .then(complete)
              .catch (data, status, headers, config) ->
                # Catch any exceptions that happen when saving the form data and log them.
                # General exception handlers should show any necessary error dialogs.
                # We don't need to do anything here.
                crtLog.error('crtForm.submit', 'error', data, status, headers, config)
                crtPromise.reject({ data, status, headers, config })

          return # pre link
        post: ($scope, element, attrs, controllers) ->
          [ crtForm, form ] = controllers

          # crtLog.debug('crtForm.link.post')

          # Delay the initialization of the form until after child directives have
          # sorted themselves out. If we don't use $timeout, things like ngRepeats aren't
          # evaluated properly and our initial error reporting doesn't attribute errors
          # to the correct places:
          $timeout(
            ->
              if attrs.errors
                crtForm.setReportingAllErrors(crtString.booleanAttr(attrs.errors))
              crtForm.revalidate()
              $scope.$watch(
                ->
                  crtForm.model
                ->
                  form.$dirty = true
                  crtForm.revalidate()
                true
              )
              return
            crtConfig.form.initialValidationDelay
          )

          return
      }
  }

module.exports.factory 'crtFormUtil', $DI (crtLog, $interpolate) ->
  parseInputName = ($scope, crtForm, attr) ->
    name  = $interpolate(attr)($scope)
    parts = name.split(".")
    prefixParts = crtForm.modelPrefix.split(".")
    for prefixPart in prefixParts
      if parts.length > 0 && parts[0] == prefixPart
        parts = _.drop(parts, 1)
      else
        break
    parts.join(".")

  allPrefixes = (field) ->
    if field && field.length > 0
      parts = field.split(".")
      ans = []
      for index in [1..parts.length]
        ans.push(parts.slice(0, index).join("."))
      ans
    else []

  normalizePrefixes = (prefixes) ->
    _.chain(prefixes)
    # Remove blank prefixes:
    .map((prefix) -> $.trim(prefix))
    .filter((prefix) -> prefix.length > 0)
    # Remove duplicates:
    .sortBy((prefix) -> prefix)
    .uniq(true)
    .value()

  parsePrefixes = ($scope, attr) ->
    normalizePrefixes($.trim($interpolate(attr)($scope) ? "").split(/\s+/))

  normalizeError = (error, source) ->
    error.source  ?= source
    error.reported = false
    error.prefixes = allPrefixes(error.field)
    error

  parseError = (key) ->
    switch key
      when "river"                   then return "Must be a valid river."
      when "number"                  then return "Must be a valid number."
      when "email"                   then return "Must be a valid email address."
      when "datetime"                then return "Must be a valid date and time (dd/mm/yyyy hh:mm)."
      when "time"                    then return "Must be a valid 24 hour time (hh:mm)."
      when "location.ngr"            then return "Must be a valid 10-digit National Grid Reference."
      when "location.gps"            then return "Must be a valid WGS84 coordinate (latitude,longitude)."
      when "duration.hhmm"           then return "Must be a valid duration (number of hours or hh:mm)."
      when "bad.objectid"            then return "Must be a valid object ID."
      when "bad.email"               then return "Must be a valid email address."
      else return key

  return {
    parseInputName
    parsePrefixes
    normalizePrefixes
    normalizeError
    parseError
  }

module.exports.directive 'crtFormGroup', $DI (crtLog, $timeout, crtConfig, crtFormUtil) ->
  return {
    restrict: 'A'
    scope: true
    require: [ '^crtForm' ]
    controller: $DI ($scope) ->
      $scope.prefixes = []
      return
    compile: (element, attrs, controllers) ->
      return {
        pre: ($scope, element, attrs, controllers) ->
          [ crtForm ] = controllers

          $scope.prefixes = crtFormUtil.parsePrefixes($scope, attrs.crtFormGroup)

          # crtLog.debug('crtFormGroup.link.pre', $scope.prefixes)

          # When a new input is added, we make sure we're reporting against its name.
          # This allows us to write <div crt-form-group> without any attribute value
          # and scaffold the array of prefixes from child inputs:
          $scope.$on 'form:inputAdded', (evt, name) ->
            evt.stopPropagation()
            $scope.prefixes = crtFormUtil.normalizePrefixes($scope.prefixes.concat([ name ]))
            # crtLog.debug("crtFormGroup.$on form:inputAdded", $scope.prefixes)

            # As a convenience, add a "for" attribute to any labels that don't already have it:
            element.find("label").each ->
              elem = angular.element(this)
              unless elem.attr("for")
                elem.attr("for", name)
              return

            return

          # If prefixes change, broadcast the changes to reporters.
          # Note the use of `$timeout` - this is because prefixes can change
          # during DOM construction when reporters aren't in the DOM yet:
          prefixesTimer = null
          $scope.$watch 'prefixes', (newValue, oldValue) ->
            # crtLog.debug('crtFormGroup.watch prefixes', newValue, oldValue)
            if prefixesTimer
              $timeout.cancel(prefixesTimer)
            prefixesTimer = $timeout ->
              prefixesTimer = null
              $scope.$broadcast('form:registerPrefixes', newValue)
              return

          return
        post: ($scope, element, attrs, controllers) ->
          [ crtForm ] = controllers

          # crtLog.debug('crtFormGroup.link.post', $scope.prefixes)

          element.addClass("form-group")

          $scope.errorsUpdated = ->
            $scope.errorLevel = null

            if $scope.readyToReportErrors
              $scope.reportingErrors = true
              $scope.$broadcast('form:setReportingErrors', true)

            if $scope.reportingErrors
              for prefix in $scope.prefixes
                errors = crtForm.errorsByPrefix[prefix]
                # crtLog.debug("crtFormGroup.errorsUpdated", prefix, errors)
                if errors
                  for error in errors
                    switch error.level
                      when 'warning'
                        $scope.errorLevel = 'warning'
                      when 'error'
                        $scope.errorLevel = 'error'
                        return
            return

          $scope.$watch((-> crtForm.validationCount), $scope.errorsUpdated)
          $scope.errorsUpdated()

          errorLevelUpdated = ->
            switch $scope.errorLevel
              when 'warning' then element.addClass('has-warning').removeClass('has-error')
              when 'error'   then element.addClass('has-error').removeClass('has-warning')
              else                element.removeClass('has-error has-warning')

          $scope.$watch('errorLevel', errorLevelUpdated)

          # When an input is changed, tell associated reporters to start showing errors.
          # We don't cancel the event as crtForm will use it to revalidate the model:
          $scope.$on 'form:inputUpdated', (evt, input, errors) ->
            # crtLog.debug("crtFormGroup.$on form:inputUpdated", input, errors, new Date().getTime())
            unless $scope.reportingErrors
              $scope.readyToReportErrors = true
            return

          $scope.reportingErrors = crtForm.reportingAllErrors # reporting errors?
          $scope.$on 'form:setReportingErrors', (evt, value) ->
            # crtLog.debug('crtFormGroup.$on form:setReportingErrors', value, new Date().getTime())
            $scope.reportingErrors = value
            return

          return
      }
  }

module.exports.factory 'crtErrorReporterDirective', $DI (crtLog, crtFormUtil) ->
  (directiveName, template, linkOther) ->
    return {
      restrict: 'A'
      scope: true
      require: [ '^crtForm' ]
      template: template
      link: ($scope, element, attrs, controllers) ->
        [ crtForm ] = controllers

        $scope.prefixes = crtFormUtil.parsePrefixes($scope, attrs[directiveName])

        # crtLog.debug("#{directiveName}.link", $scope.prefixes)

        $scope.reportErrorHere = (error) ->
          true

        $scope.errorsUpdated = ->
          $scope.errors   = []
          $scope.warnings = []
          for prefix in $scope.prefixes
            errors = crtForm.errorsByPrefix[prefix]
            # crtLog.debug("#{directiveName}.errorsUpdated", prefix, crtForm.errors, errors, _.map(errors ? [], $scope.reportErrorHere))
            if errors
              for error in errors when $scope.reportErrorHere(error)
                switch error.level
                  when 'warning' then unless _.contains($scope.warnings, error) then $scope.warnings.push(error)
                  when 'error'   then unless _.contains($scope.errors,   error) then $scope.errors.push(error)
          return

        $scope.$watch((-> crtForm.validationCount), $scope.errorsUpdated)
        $scope.errorsUpdated()

        $scope.$on 'form:registerPrefixes', (evt, prefixes) ->
          # crtLog.debug("#{directiveName}.$on form:registerPrefixes", prefixes)
          if $scope.prefixes.length == 0
            $scope.prefixes = prefixes
            $scope.errorsUpdated()
          return

        $scope.reportingErrors = crtForm.reportingAllErrors
        $scope.$on 'form:setReportingErrors', (evt, value) ->
          # crtLog.debug("#{directiveName}.setReportingErrors", value)
          $scope.reportingErrors = value
          return

        linkOther($scope, element, attrs, crtForm)

        return
    }

module.exports.directive 'crtFormErrors', $DI (crtErrorReporterDirective) ->
  crtErrorReporterDirective 'crtFormErrors', require('./form-errors.tpl.html'), ($scope, element, attrs, crtForm) ->
    $scope.reportErrorHere = (error) ->
      if _.contains($scope.prefixes, error.field)
        error.reported = true
        true
      else
        false
    return

module.exports.directive 'crtFormBadge', $DI ($timeout, crtErrorReporterDirective) ->
  crtErrorReporterDirective 'crtFormBadge', require('./form-badge.tpl.html'), ($scope, element, attrs, crtForm) ->
    $scope.reportErrorHere = (error) ->
      error.reported = true
      true

    $scope.popoverDisplay = 'none'

    popover = element.find(".popover")
    element.on 'click', (evt) ->
      $scope.$apply ->
        evt.stopPropagation()
        $scope.popoverDisplay = 'block'
        # Wait until the popup is visible to adjust its position:
        $timeout ->
          $scope.popoverTop  = (element.height()/2 - popover.outerHeight()/2) + "px"
          $scope.popoverLeft = element.width() + "px"
        return

    closeHandler = ->
      $scope.$apply ->
        $scope.popoverDisplay = 'none'
        return
      return

    angular.element("body").on('click', closeHandler)

    $scope.$on '$destroy', ->
      angular.element("body").off('click', closeHandler)

    return

module.exports.directive 'crtUnreportedErrors', $DI (crtErrorReporterDirective) ->
  crtErrorReporterDirective 'crtUnreportedErrors', require('./unreported-errors.tpl.html'), ($scope, element, attrs, crtForm) ->
    $scope.reportErrorHere = (error) ->
      !error.reported
    return

module.exports.directive 'crtNumberOfErrors', $DI (crtLog) ->
  return {
    restrict: 'A'
    template: require './number-of-errors.tpl.html'
    require: [ '^crtForm' ]
    link: ($scope, element, attrs, controllers) ->
      [ crtForm ] = controllers

      $scope.submitDescription = attrs.submitDescription ? "proceed"

      $scope.reportingErrors = crtForm.reportingAllErrors
      $scope.$on 'form:setReportingErrors', (evt, value) ->
        # crtLog.debug("#{directiveName}.setReportingErrors", value)
        $scope.reportingErrors = value
        return

      $scope.$watch (-> crtForm.numWarnings), (value) -> $scope.numWarnings = value
      $scope.$watch (-> crtForm.numErrors),   (value) -> $scope.numErrors   = value

      return
  }

module.exports.factory 'crtInputDirective', $DI (crtLog, $timeout, crtConfig, crtFormUtil) ->
  return (directiveName, restrict = 'E') ->
    return {
      restrict: restrict
      scope: true
      require: [ directiveName, '?ngModel', '^?crtForm', '^?form' ]
      controller: $DI ->
        return this
      compile: (element, attrs, controllers) ->
        return {
          pre: ($scope, element, attrs, controllers) ->
            [ input, ngModel, crtForm, form ] = controllers

            unless crtForm && form && ngModel then return

            input.ngModel = ngModel

            input.name = crtFormUtil.parseInputName($scope, crtForm, attrs.name ? attrs.ngModel)

            unless attrs.name
              element.attr('name', input.name)

            $scope.$emit('form:inputAdded', input.name)

            return
          post: ($scope, element, attrs, controllers) ->
            [ input, ngModel, crtForm, form ] = controllers

            unless crtForm && form && ngModel then return

            # Suppress the default HTML5 error reporting popups in browsers like Chrome:
            element.on 'invalid', (evt) ->
              evt.preventDefault()

            # In HTML 5 browsers, it is possible for the string value of an input to change
            # without triggering $viewChangeListeners. We need to capture these events to
            # intercept parse errors. However, intercepting these events and calling `inputUpdated`
            # can cause duplicate triggers.
            #
            # To get around this, we use `$timeout`. We set a timer when listening to the input
            # event and cancel it when `inputUpdated` is called. This way, if the input is valid and
            # `inputUpdated` is called by `$viewChangeListeners`, we still only get one call:
            calmDomEventsTimer = null

            # In HTML5-compatible browsers we listen to the `input` event so we can detect
            # changes in elements of type "number", "date", "email" and so on:
            createDomEventListener = ->
              # The use of $apply and $timeout is intentional here. It delays the call to `inputUpdated`
              # until after the digest where $viewChangeListeners would be called if the input was valid:
              return ->
                $scope.$apply ->
                  # crtLog.debug("#{directiveName}.domEventListener", ngModel.$modelValue, ngModel.$error)
                  calmDomEventsTimer = $timeout(-> inputUpdated())
                  return
                return

            # We delay emitting form:inputUpdated events to reduce the amount of recalculation on the form:
            inputUpdatedTimer = null

            inputUpdated = ->
              # crtLog.debug("#{directiveName}.inputUpdated", ngModel.$modelValue, ngModel.$error)

              # Synchronous part of this function:
              syncInputUpdated = ->
                # Certain HTML5 input types like "number" don't yield values when they are invalid.
                # However, Angular uses changes in values to trigger validation.
                #
                # This means if the user types "abc" into a number field, Angular doesn't recognise it.
                # We listen to validity separately here so we can report on bad values in a generic way:
                if element.get(0).validity
                  newError = element.get(0).validity.badInput
                  oldError = ngModel.$error[attrs.type]
                  if newError != oldError
                    ngModel.$setValidity(attrs.type, !newError)

                errors = for key, value of ngModel.$error when value
                  { level: "error", field: input.name, message: crtFormUtil.parseError(key) }

                # crtLog.debug("#{directiveName}.form:inputUpdated", input.name, errors)

                $scope.$emit('form:inputUpdated', input.name, errors)

                return

              $timeout.cancel(calmDomEventsTimer)
              # $timeout.cancel(inputUpdatedTimer)
              # inputUpdatedTimer = $timeout(syncInputUpdated, crtConfig.form.fastValidationDelay)
              syncInputUpdated()

              return

            $scope.$watch (-> crtForm.enabled), (value) ->
              # crtLog.debug("#{directiveName}.$watch crtForm.enabled", value)
              if value then element.removeAttr("disabled") else element.attr("disabled", "disabled")

            $scope.$on '$destroy', ->
              $scope.$emit('form:inputRemoved', input.name)
              return

            if element.is("select")
              element.on('change', createDomEventListener())
            else
              # Listen for HTML5 `input` events so we can detect changes in fields
              # even when they contain invalid values:
              element.on('input', createDomEventListener())

            return
        }
    }

module.exports.directive 'input', $DI (crtInputDirective) ->
  crtInputDirective('input')

module.exports.directive 'crtSelect', $DI (crtInputDirective) ->
  crtInputDirective('crtSelect', 'A')

module.exports.directive 'textarea', $DI (crtInputDirective) ->
  crtInputDirective('textarea')

module.exports.directive 'crtOnEnter', $DI (crtLog, $parse) ->
  return {
    restrict: 'A'
    link: ($scope, element, attrs) ->
      # We parse the expression but don't evaluate it:
      $scope.onEnter = if attrs.crtOnEnter then $parse(attrs.crtOnEnter) else (->)

      element.on 'keyup', (evt) ->
        $scope.$apply ->
          if evt.keyCode == 13
            evt.preventDefault()
            $scope.onEnter($scope)
          return
        return
      return
  }

module.exports.directive 'crtSubmitOnEnter', $DI (crtLog, $parse) ->
  return {
    restrict: 'A'
    require: '^crtForm'
    link: ($scope, element, attrs, crtForm) ->
      $scope.complete =
        if attrs.complete then $parse(attrs.complete)($scope) else (->)

      element.on 'keyup', (evt) ->
        $scope.$apply ->
          if evt.keyCode == 13
            evt.preventDefault()
            crtForm.submit($scope.complete ? (->))
          return
        return
      return
  }

module.exports.directive 'crtSubmitButton', $DI (crtLog, $parse) ->
  return {
    restrict: 'A'
    require: '^crtForm'
    replace: true
    scope: complete: '=?'
    transclude: true
    template: require './submit-button.tpl.html'
    controller: $DI ($scope) ->
      $scope.errors = []
      $scope.loading = false
      return
    link: ($scope, element, attrs, crtForm) ->
      beforeSubmit = if attrs.beforeSubmit then $parse(attrs.beforeSubmit) else (->)

      $scope.$watch (-> crtForm.enabled), (enabled) ->
        if enabled then element.show() else element.hide()

      $scope.submitClicked = ->
        beforeSubmit($scope)
        $scope.loading = true
        crtForm
        .submit($scope.complete ? (->))
        .finally(
          (result) -> $scope.loading = false
          (error)  -> $scope.loading = false
        )

      return
  }

module.exports.directive 'crtConfirmNavigation', $DI (crtPage) ->
  return {
    restrict: 'A'
    require: 'form'
    link: ($scope, element, attrs, form) ->
      message = if attrs.crtConfirmNavigation?.length > 0
        attrs.crtConfirmNavigation
      else
        "You have unsaved changes that will be lost."

      crtPage.addUnloadListener $scope, ->
        unless form.$pristine
          return message
  }

